import { PopupHeader } from "@/common/popups/common/popup-header";
import { cn } from "@/utils/cn";
import { renderDefinedTrue } from "@/utils/react-conditional";
import React from "react";

export interface IPopupBackgroundProps {
  title?: React.ReactNode;
  className?: string;
  inlineStyle?: React.CSSProperties;
  children?: React.ReactNode;
}

export const PopupBackground = React.memo(function PopupBackground(
  props: IPopupBackgroundProps
) {
  return (
    <div
      className={cn(
        "w-80 space-y-5 overflow-hidden rounded-3xl border border-outline/20 bg-surface px-5 pt-7.5 pb-5",
        props.className
      )}
      style={props.inlineStyle}
    >
      {renderDefinedTrue(props.title, () => (
        <PopupHeader>{props.title}</PopupHeader>
      ))}
      {props.children}
    </div>
  );
});
